import { Component } from '@angular/core';
import { SharedService } from 'src/app/shared/services/shared.service';
import { BottomFooterComponent } from '../bottom-footer/bottom-footer.component';
import { TopNavbarComponent } from '../top-navbar/top-navbar.component';

@Component({
  selector: 'app-competitor-comparison',
  standalone: true,
  templateUrl: './competitor-comparison.component.html',
  styleUrl: './competitor-comparison.component.scss',
  imports: [TopNavbarComponent, BottomFooterComponent],
})
export class CompetitorComparisonComponent {
  features: Feature[] = [
    { name: 'eSAFE Bound Book', basic: true, standard: true, pro: true },
    { name: 'InStore Automatic Backup', basic: true, standard: true, pro: true },
    { name: 'Destroyed, Lost & Stolen Dispositions', basic: true, standard: true, pro: true },
    { name: 'Bound Book Searchability', basic: true, standard: true, pro: true },
    { name: 'Attach images and documents', basic: true, standard: true, pro: true },
    { name: 'Staff Accounts', basic: false, standard: false, pro: '25 staff accounts' },
    { name: 'fast4473™', basic: false, standard: true, pro: true },
    { name: 'fast3310', basic: false, standard: true, pro: true },
    { name: 'fastinventory', basic: false, standard: true, pro: true },
    { name: 'TouchPoint Contact Management System', basic: false, standard: true, pro: true }
  ];

  plans = [
    { name: 'BASIC', price: '$10/Month', highlight: false },
    { name: 'STANDARD', price: '$30/month', highlight: false },
    { name: 'PRO', price: 'from $37.50/month*', highlight: true }
  ];
  // Helper to get value for a plan
  getValue(feature: Feature, planName: string): boolean | string {
    const key = this.planKey(planName);
    return (feature as any)[key];
  }

  // Map plan name to feature key
  planKey(planName: string): string {
    const map: { [key: string]: string } = {
      'BASIC': 'basic',
      'STANDARD': 'standard',
      'PRO': 'pro'
    };
    return map[planName] || 'basic';
  }

  // Determine display type: 'check', 'cross', 'text'
  getDisplayType(value: boolean | string): 'check' | 'cross' | 'text' {
    if (typeof value === 'string') return 'text';
    if (value === true) return 'check';
    if (value === false) return 'cross';
    return 'cross';
  }
  constructor(public sharedService: SharedService) {}

  ngOnInit() {}
}

interface Feature {
  name: string;
  basic: boolean | string;
  standard: boolean | string;
  pro: boolean | string;
}